import AuthGuard from '../components/AuthGuard';
import InnerLayout from '../components/InnerLayout';
import { useNavigate } from 'react-router-dom';

export default function SupportPage() {
  const navigate = useNavigate();
  return (
    <div
      className="max-w-md mx-auto min-h-screen"
      style={{
        backgroundImage: 'url(/images/qingtui_beijing.png)',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundColor: '#f8f3ec',
      }}
    >
      <AuthGuard />

      {/* Header */}
      <div className="relative pt-4 px-4">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white mb-2"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <div className="flex flex-col items-center gap-3 justify-center relative pt-[30px]">
          <h4>在线客服</h4>
        </div>
      </div>

      <div className="mx-auto max-w-md px-4">
        <div className="mt-5 rounded-2xl bg-white p-4 shadow">
          <div className="text-sm">联系客服</div>
          <div className="mt-2 text-[12px] text-gray-600">工作时间：每天 09:00 - 18:00</div>
        </div>
        <div className="mt-4">
          <a href="#" className="block w-full rounded-xl bg-red-600 py-3 text-center text-white">开始咨询</a>
        </div>
      </div>
    </div>
  );
}